import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { yupLocalized } from "@ryde/shared";

import { BulkDriversMessageFormFieldsEnum } from "./bulk-drivers-message.models";

export const useBulkDriversMessageValidation = () => {
  const { t } = useTranslation();
  const basePath = "driver.sendDriverMessageForm";

  const bulkDriversMessageResolver = useMemo(() => {
    return {
      [BulkDriversMessageFormFieldsEnum.isEmail]: yupLocalized
        .boolean()
        .optional(),

      [BulkDriversMessageFormFieldsEnum.isSms]: yupLocalized
        .boolean()
        .optional(),

      [BulkDriversMessageFormFieldsEnum.isPush]: yupLocalized
        .boolean()
        .optional(),

      [BulkDriversMessageFormFieldsEnum.subject]: yupLocalized
        .string()
        .when(BulkDriversMessageFormFieldsEnum.isEmail, {
          is: true,
          then: schema =>
            schema.required(
              t("validation.required", {
                path: t(`${basePath}.subject`),
              }),
            ),
          otherwise: schema => schema.notRequired(),
        }),

      [BulkDriversMessageFormFieldsEnum.message]: yupLocalized
        .string()
        .required(
          t("validation.required", {
            path: t(`${basePath}.message`),
          }),
        ),
    };
  }, [t]);

  return {
    bulkDriversMessageResolver,
  };
};
